import { useState, useMemo, useEffect, useRef } from "react";
import useTranslation from "@/hooks/use_translation";
import SearchIcon from "@/sprout/icons/search";
import { TextInput } from "@/sprout/text_input";
import { IconLocationInput } from "@components/ui/location_input";
import { Location } from "@components/ui/location_input";
import { PrimaryButton } from "@/sprout/button";

export const SearchBar = ({ justify = "end" }) => {
  const { t } = useTranslation("jobSearch");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [location, setLocation] = useState(null as null | Location);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.metaKey && event.key === "k" && inputRef.current) {
        inputRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const searchDestination = useMemo(() => {
    const params = new URLSearchParams({
      keyword: searchKeyword,
      location: location?.display_name || "",
    });

    return "/job_search?" + params.toString();
  }, [searchKeyword, location]);

  return (
    <div className={`flex flex-col gap-3 w-full md:flex-row justify-${justify}`}>
      <div className="flex gap-3 w-full flex-col gap-3 md:flex-row md:max-w-153">
        <div className="flex basis-full md:max-w-75">
          <TextInput
            ref={inputRef}
            placeholder={t("searchPlaceholder")}
            onChange={(event) => setSearchKeyword(event.currentTarget.value || "")}
            maxLength={255}
            value={searchKeyword}
            narrow={true}
            icon={<SearchIcon />}
          />
        </div>
        <div className="flex basis-full md:max-w-75">
          <IconLocationInput onChange={setLocation} value={location} />
        </div>
      </div>
      <PrimaryButton link href={searchDestination}>
        {t("search")}
      </PrimaryButton>
    </div>
  );
};
